import { useState, useEffect } from 'react';
import LivePlayer from './LivePlayer';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex flex-col">
      {/* Navbar */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-black/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
        <div className="px-4 sm:px-8 lg:px-20 py-4 lg:py-6 flex items-center justify-between">
          <div className="flex items-center gap-2 sm:gap-3">
            <img 
              src="https://static.readdy.ai/image/90cdc5753254eaf7f1dcae8cf1c8be47/35a559514bc9a3dc6d2caf1f9c98bb98.png" 
              alt="Hits Collections Station Logo" 
              className="h-10 w-10 sm:h-12 sm:w-12 lg:h-16 lg:w-16 object-contain"
            />
            <span className="text-[#d4af37] font-bold text-sm sm:text-lg lg:text-2xl" style={{ fontFamily: 'Playfair Display, serif' }}>
              Hits Collections Station
            </span>
          </div>
          
          <div className="hidden md:flex items-center gap-4 lg:gap-8">
            <a href="#hero" className="text-white/80 hover:text-[#d4af37] transition-colors duration-300 text-xs lg:text-sm font-medium whitespace-nowrap cursor-pointer">
              INICIO
            </a>
            <a href="#schedule" className="text-white/80 hover:text-[#d4af37] transition-colors duration-300 text-xs lg:text-sm font-medium whitespace-nowrap cursor-pointer">
              PROGRAMACIÓN
            </a>
            <a href="#news" className="text-white/80 hover:text-[#d4af37] transition-colors duration-300 text-xs lg:text-sm font-medium whitespace-nowrap cursor-pointer">
              NOTICIAS
            </a>
            <a href="#contact" className="text-white/80 hover:text-[#d4af37] transition-colors duration-300 text-xs lg:text-sm font-medium whitespace-nowrap cursor-pointer">
              CONTACTO
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="flex-1 flex items-center justify-center relative overflow-hidden pt-20 sm:pt-24">
        {/* Animated Background Waves */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-1/4 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#d4af37] to-transparent animate-pulse"></div>
          <div className="absolute top-1/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#d4af37] to-transparent animate-pulse" style={{ animationDelay: '0.5s' }}></div>
          <div className="absolute top-1/2 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#d4af37] to-transparent animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-2/3 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#d4af37] to-transparent animate-pulse" style={{ animationDelay: '1.5s' }}></div>
        </div>

        <div className="relative z-10 text-center px-4 sm:px-8 max-w-5xl mx-auto">
          <div className="mb-6 sm:mb-8">
            <img 
              src="https://static.readdy.ai/image/90cdc5753254eaf7f1dcae8cf1c8be47/35a559514bc9a3dc6d2caf1f9c98bb98.png" 
              alt="Hits Collections Station" 
              className="h-20 w-20 sm:h-24 sm:w-24 lg:h-32 lg:w-32 mx-auto mb-4 sm:mb-6 object-contain"
            />
            <h1 className="text-3xl sm:text-4xl lg:text-6xl font-bold text-[#d4af37] mb-3 sm:mb-4 px-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Hits Collections Station
            </h1>
            <p className="text-white/70 text-sm sm:text-base lg:text-lg px-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              La mejor música, las mejores voces, todo el día
            </p>
          </div>

          <LivePlayer />

          <div className="mt-8 sm:mt-12 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 px-4">
            <a 
              href="#schedule" 
              className="w-full sm:w-auto px-6 sm:px-8 py-3 bg-[#d4af37] text-black font-semibold rounded-full hover:shadow-lg hover:shadow-[#d4af37]/50 transition-all duration-300 text-xs sm:text-sm whitespace-nowrap cursor-pointer text-center"
            >
              VER PROGRAMACIÓN
            </a>
            <a 
              href="#contact" 
              className="w-full sm:w-auto px-6 sm:px-8 py-3 border border-[#d4af37] text-[#d4af37] font-semibold rounded-full hover:bg-[#d4af37] hover:text-black transition-all duration-300 text-xs sm:text-sm whitespace-nowrap cursor-pointer text-center"
            >
              CONTÁCTANOS
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hidden sm:block absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-[#d4af37] rounded-full flex items-start justify-center p-2">
          <div className="w-1 h-2 bg-[#d4af37] rounded-full"></div>
        </div>
      </div>
    </section>
  );
}
